module.exports = __webpack_public_path__ + "static/img/10044.d4d72462.png";